import { Reveal, Overline } from "./Reveal";

const STEPS = [
  { n: "01", title: "Attract", desc: "Create demand through content, advertising, and strategic messaging.", flow: ["Content", "Creative", "Paid Media"] },
  { n: "02", title: "Capture", desc: "Turn attention into identifiable opportunities.", flow: ["Website", "Landing Pages", "Forms", "Calls", "Messages"] },
  { n: "03", title: "Nurture", desc: "Automatically follow up with every prospect.", flow: ["CRM", "SMS", "Email", "AI Conversations"] },
  { n: "04", title: "Convert", desc: "Move qualified prospects toward appointments and sales.", flow: ["Qualification", "Booking", "Pipeline", "Sales"] },
  { n: "05", title: "Optimize", desc: "Use performance data to improve the entire system.", flow: ["Analytics", "Testing", "Optimization", "Scale"] },
];

export default function System() {
  return (
    <section id="system" data-testid="system-section" className="border-t border-line bg-surface px-6 py-28 md:px-12 md:py-40">
      <div className="mx-auto max-w-[1600px]">
        <Reveal><Overline>03 — The Polemikoi Growth System</Overline></Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-8 font-display text-3xl font-extrabold uppercase leading-[1.05] tracking-tight text-white md:text-5xl lg:text-6xl">
            One connected <span className="text-zinc-500">growth system</span>
          </h2>
        </Reveal>

        <div className="mt-24 grid grid-cols-1 gap-12 md:grid-cols-5 md:gap-6">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.12} className="relative">
              <div data-testid={`system-step-${s.n}`} className="group border-t-2 border-line pt-8 transition-colors duration-500 hover:border-crimson">
                <div className="flex items-center gap-3">
                  <span className="h-2 w-2 bg-zinc-600 transition-colors duration-500 group-hover:animate-pulse group-hover:bg-crimson" />
                  <span className="font-mono text-xs tracking-[0.25em] text-zinc-500">STEP {s.n}</span>
                </div>
                <h3 className="mt-6 font-display text-2xl font-extrabold uppercase tracking-tight text-white md:text-3xl">{s.title}</h3>
                <p className="mt-4 text-sm leading-relaxed text-zinc-400">{s.desc}</p>
                <div className="mt-6 flex flex-wrap gap-x-2 gap-y-1.5 font-mono text-[10px] uppercase tracking-wider text-zinc-500">
                  {s.flow.map((f, j) => (
                    <span key={f}>
                      <span className="text-zinc-300">{f}</span>
                      {j < s.flow.length - 1 && <span className="ml-2 text-crimson">→</span>}
                    </span>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
